//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.DraftingAid.js";
let d=[[],[[["lines"],"SetText",{},1,0],[["n_lines"],"GetText",{R_:{lines:""}},0,0],[["usym_prefs"],"SetUserSymbolPreferences",{},1,0],[["size_type","length_or_scale","height_or_aspect_ratio"],"SetUserSymbolSize",{},3,0],[["size_type","length_or_scale","height_or_aspect_ratio"],"GetUserSymbolSize",{},0,0],[[],"GetUserSymbolPreferences",{R_:{usym_prefs:"Annotations.UserSymbolPreferences"}},0,0]],[]];
SPLM.Annotations.SimpleDraftingAid = class extends SPLM.Annotations.DraftingAid{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.SimpleDraftingAid";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;